<template>
  <section class="py-0">

      <aside class="bg-primary bg-gradient rounded-3 p-0 p-sm-1 mt-1">
        <div
            class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
          <div class="mb-4 mb-xl-0">
            <div class="fs-3 fw-bold text-white">Dashboard</div>
            <div class="text-white-50">En ésta sección podrás visualizar el detalle de los registros.</div>
          </div>
          <div class="mb-4 mb-xl-0" v-if="xlsEvidencias != null || xlsEntradasSalidas != null" >
            <div class="row">
              <div class="col">
                <button type="button" class="btn btn-success btn-sm"
                        @click="descargarFotos()">
                  <FontAwesomeIcon :icon="faDownload()"/> JPG<br/>FOTOS
                </button>
              </div>
              <div class="col" v-if="xlsEntradasSalidas != null">
                <!--                  <span v-if="json_data_origen  != null">{{json_data_origen.registros}}</span>-->
                <download-excel :data="xlsEntradasSalidas" type="xlsx"
                                :export-fields="fieldsXLS"
                                class="btn btn-success btn-sm"
                                name="Entras y Salidas" worksheet="Registro de entradas y salidas"
                                title="Descargar archivo XLSX con los registros de entradas y salidas"
                >
                  <FontAwesomeIcon :icon="faDownload()"/> XLSX<br/>Registros
                </download-excel>
              </div>
              <div class="col" v-if="xlsEvidencias != null">
                <download-excel :data="xlsEvidencias" type="xlsx"
                                :export-fields="fieldsXLS"
                                class="btn btn-success btn-sm"
                                name="Evidencias" worksheet="Registro de evidencias"
                                title="Descargar archivo XLSX con los registros de evidencias"
                >
                  <FontAwesomeIcon :icon="faDownload()"/> XLSX<br/>Evidencias
                </download-excel>
              </div>
            </div>
          </div>
          <div class="ms-xl-4">
            <div class="input-group mb-2">
              <DatePicker v-model="filtros.rango"
                          range lang="es"
                          placeholder="Fechas"
                          circle
                          show-clear-button
                          :date-format="{
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric' }"
                          :disabled-start-date="disabledStartDate"
                          :disabled-end-date="disabledEndDate"
              />
            </div>
          </div>
        </div>
      </aside>

    <div class="container px-lg-3 px-xl-2 px-xxl-2 mt-2">
      <div class="row ">

        <div class="col-4" >
          <div class="input-group" >
            <span class="input-group-text">Empleado</span>
            <input v-model="filtros.empleado"
                   style="float: right;"
                   class="form-control"
                   placeholder="Nombre o número de empleado"
                   @keydown.prevent.enter="buscar()"
            />
            <button type="button" class="input-group-text" style="float: right;" @click="filtros.empleado=null"
                    v-if="filtros.empleado!=null">
              <FontAwesomeIcon :icon="faClose()" title="restablecer nombre del empleado"/>
            </button>
          </div>
        </div>
        <div class="col-3" >
          <div class="input-group" >
            <span class="input-group-text">Cliente</span>
            <input v-model="filtros.cliente"
                   style="float: right;"
                   class="form-control"
                   placeholder="Nombre o id de cliente"
                   @keydown.prevent.enter="buscar()"
            />
            <button type="button" class="input-group-text" style="float: right;" @click="filtros.cliente=null"
                    v-if="filtros.cliente!=null">
              <FontAwesomeIcon :icon="faClose()" title="restablecer nombre del cliente"/>
            </button>
          </div>
        </div>
        <div class="col-3" >
          <div class="input-group" >
            <span class="input-group-text">Sucursal</span>
            <input v-model="filtros.sucursal"
                   style="float: right;"
                   class="form-control"
                   placeholder="Nombre o id de sucursal"
                   @keydown.prevent.enter="buscar()"
            />
            <button type="button" class="input-group-text" style="float: right;" @click="filtros.sucursal=null"
                    v-if="filtros.sucursal!=null">
              <FontAwesomeIcon :icon="faClose()" title="restablecer nombre de la sucursal"/>
            </button>
          </div>
        </div>

        <div class="col-2">
          <button type="button" class="btn btn-success" style="float: right;" @click="buscar()">
            <FontAwesomeIcon :icon="faSearch()"/> Buscar
          </button>
        </div>

      </div>
    </div>

    <aside class="bg-gradient rounded-3 p-0 p-sm-1 mt-1 table-responsive">
        <table class="table table-striped table-hover" id="table-dash">
          <thead>
            <tr>
              <th scope="col">CLIENTE</th>
              <th scope="col" title="Sucursal/Unidad">
                <PopperC content="Sucursal/Unidad" >
                  <button class="popTitle">SUC/UNI</button>
                </PopperC>
              </th>
              <th scope="col">TURNO</th>
              <th scope="col" title="Deben asistir">
                <PopperC content="Deben asistir" >
                  <button class="popTitle">DA</button>
                </PopperC>
              </th>
              <th scope="col" title="Asistencias" >
                <PopperC content="Asistencias" >
                  <button class="popTitle">A</button>
                </PopperC>
              </th>
              <th scope="col" title="Evidencias" >
                <PopperC content="Evidencias" >
                  <button class="popTitle">E</button>
                </PopperC>
              </th>
              <th scope="col" title="Tomadas evidencias">
                <PopperC content="Tomadas evidencias" >
                  <button class="popTitle">R</button>
                </PopperC>
              </th>
              <th scope="col" title="Número de empleado">
                <PopperC content="Número de empleado" >
                  <button class="popTitle">#</button>
                </PopperC>
              </th>
              <th scope="col">NOMBRE Y APELLIDOS</th>
              <th scope="col" title="Tipo de registro">
                <PopperC content="Tipo de registro" >
                  <button class="popTitle">Registro</button>
                </PopperC>
              </th>
              <th scope="col">FECHA</th>
              <th scope="col">HORA</th>
              <th scope="col" title="Horas trabajadas (Entrada/Salida)">
                <PopperC content="Horas trabajadas (Entrada/Salida)" >
                  <button class="popTitle">Hrs</button>
                </PopperC>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="clientes != null">
              <template v-for="c in clientes" :key="c">
                <tr>
                  <fila-component :datosOrigen="c" @verDetalle="verDetalle"/>
                </tr>
              </template>
            </template>
            <tr v-else>
              <td colspan="13" style="text-align: center;"> <h6>SIN DATOS</h6> </td>
            </tr>
          </tbody>
      </table>
      </aside>

  </section>

  <div v-if="showModal" class="modal fade show modal-lg"
       tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
       style="display:block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
<!--        <div class="modal-header">-->
<!--          -->
<!--        </div>-->
        <div class="modal-body">

          <div class="card mb-3">
            <div class="row g-0">
              <div class="col-md-4">
                <div style="padding: 5px">
                  <vue-image-zoomer :click-zoom="true"
                                    click-message="Zoom"
                                    :img-width="200"
                                    :regular="'data:image/jpg;base64, '+imgModal" />
                  <button type="button" class="btn btn-light"
                          @click="descargarFoto()"
                          style="float: left;
                                margin-top: -37px;
                                display: block;
                                z-index: 1000;
                                position: absolute;"
                  ><FontAwesomeIcon :icon="faDownload()"/></button>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <h5 class="card-title">
                    {{registroActivo[4]}}
                  </h5>
                  <p class="card-text">
                    <span class="badge rounded-pill bg-primary">
                      # Empleado {{registroActivo[3]}}
                    </span>
                    <span class="badge rounded-pill bg-light text-dark">
                      <span v-if="registroActivo[2]==='Entrada' || registroActivo[2]==='Salida'">Turno</span>
                      {{registroActivo[2]}}
                    </span>
                    <span class="badge rounded-pill bg-success">
                      <p class="card-text">{{registroActivo[5]}}</p>
                    </span>
                  </p>

                  <p class="card-text"><small class="text-muted">{{registroActivo[11]}}</small></p>
                </div>
              </div>
              <div class="col-md-12">
                <div v-if="registroActivo[14]!=null" style="height: 200px; padding: 5px;">
                  <l-map ref="map" :zoom="13"
                         :center="[registroActivo[14].lat, registroActivo[14].lng]"
                         style="width:100%; height:100%;">
                    <l-tile-layer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        layer-type="base"
                        name="OpenStreetMap"/>
                    <l-marker :lat-lng="[registroActivo[14].lat, registroActivo[14].lng]" :draggable=false></l-marker>
                  </l-map>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button"  @click="cerrarDetalle()" :class="'btn btn-primary'" >Cerrar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faClose, faDownload, faSearch} from "@fortawesome/free-solid-svg-icons";
import {inject} from "vue";
import {DashboardService} from "@/services/DashboardService";
import FilaComponent from "@/components/dashboard/Fila-Component.vue";
import {LMap, LMarker, LTileLayer} from "@vue-leaflet/vue-leaflet";

export default {
  name: 'Dashboard-Component',
  inject: ['$axios', '$localStorageService'],
  components: {FilaComponent, FontAwesomeIcon,
    LMap,
    LTileLayer,
    LMarker, },
  setup() {
    return {
      srv_dashboardService: new DashboardService( inject('$axios'))
    }
  },
  data() {
    return {
      numeroEmpleado: null,
      json_data_origen: null,
      xlsEntradasSalidas: null,
      xlsEvidencias: null,
      clientes: null,
      fieldsXLS: {
        'Cliente': '0',
        'Turno': '2',
        'Sucursal/Unidad': '1',
        'Núm. Empleado': '3',
        'Nombre': '4',
        'Tipo de Registro': '5',
        'Fecha/Hora del registro': '11',
        'Ubicacion': '12',
        'Foto': '10',
        'Metadatos': '9'
      },
      filtros: {
        rango: [
            new Date(new Date().toDateString()),
          new Date(new Date().toDateString())
        ]
      },
      disabledStartDate: {
        to: new Date()
      },
      disabledEndDate: {
        from: new Date()
      },
      showModal: false,
      imgModal: null,
      registroActivo: null,
    }
  },
  created() {
    this.moment = moment;
  },
  async mounted() {

    // this.disabledStartDate.to.setFullYear(2000)
    // this.disabledStartDate.from.setDate(new Date())

    if (this.$localStorageService.isAuth()) {
      this.numeroEmpleado = this.$localStorageService.getNumEmpleado();
    }

    this.buscar();

  },
  methods: {
    faDownload() {
      return faDownload;
    },
    faSearch() {
      return faSearch;
    },
    faClose() {
      return faClose;
    },
    buscar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.json_data_origen = null;

      this.srv_dashboardService.obtenerReporte(this.filtros)
          .then((response) => {
            this.json_data_origen = response;
            this.json_data_origen.registros.forEach(r=>{
              // console.info(">>>>>>>", JSON.parse(JSON.stringify(r)))
              r[8] = this.moment(r[8]);
              r[6]= r[8].format("DD/MM/YYYY");
              r[7]= r[8].format("HH:mm:ss");
              r[11]= r[8].format("DD/MM/YYYY HH:mm:ss");
              // console.info("-{{{",r[9][0], JSON.parse(r[9]));
              try {
                const meta = JSON.parse(r[9]);
                const position = meta.find(t => t.tag === "position");
                r[12] = "(" + position.valor.lat + "," + position.valor.lng + ")"
                r[13] = "https://maps.google.com/?q="+position.valor.lat+"," + position.valor.lng;
                r[14] = {
                  lat: position.valor.lat,
                  lng: position.valor.lng
                }
              } catch (e) {
                  console.error(e);
              }
            })
            this.llenarClientesTabla();
            this.llenarDatosExportar();
            // console.info(this.json_data_origen);
            // console.info(this.clientes);

          }).catch((error) => {
            this.$swal(error.message);
            console.error(error)
          }).finally(() => load.hide());
    },

    llenarDatosExportar() {
      this.xlsEntradasSalidas = null;
      this.xlsEvidencias = null;
      if (this.json_data_origen != null && this.json_data_origen.registros.length >0) {
        const entradasSal = this.json_data_origen.registros.filter(reg => reg[5] === 'Entrada' || reg[5] === 'Salida')

        if (entradasSal.length > 0) {
          this.xlsEntradasSalidas = entradasSal;
        }

        const xlsEvidencias = this.json_data_origen.registros.filter(reg => reg[5] === 'Evidencia')
        if (xlsEvidencias.length > 0) {
          this.xlsEvidencias = xlsEvidencias;
        }
      }
    },

    llenarClientesTabla() {
      if (this.json_data_origen != null && this.json_data_origen.plantilla != null) {
        this.clientes = [];
        this.json_data_origen.plantilla.forEach(d=>{
          const nombre = d[0];
          const cliEx = this.clientes.find(c=>c.nombreCliente === nombre)
          if (cliEx == null) {
            this.clientes.push({
              "nombreCliente": nombre,
              "sucursales": this.llenarSucursalesTabla(nombre)
            });
          }
        });
      }
    },

    llenarSucursalesTabla(nombreCliente) {

      const sucursales = [];

      this.json_data_origen.plantilla
          .filter(d => d[0] === nombreCliente)
          .forEach(d=>{
            const nombreSucursal = d[1];
            const ex = sucursales.find(s => s.nombreSucursal === nombreSucursal)
            if (ex == null) {
              sucursales.push({
                "nombreSucursal": nombreSucursal,
                "turnos": this.llenarTurnosTabla(nombreCliente, nombreSucursal)
              });
            }
      });

      return sucursales;
    },

    llenarTurnosTabla(nombreCliente, nombreSucursal) {

      const turnos = [];

      this.json_data_origen.plantilla
          .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal)
          .forEach(d=>{
            const nombreTurno = d[2];
            const ex = turnos.find(s => s.nombreTurno === nombreTurno)
            if (ex == null) {
              turnos.push({
                "nombreTurno": nombreTurno,
                "deben_asistir": this.llenarDebenAsistirTabla(nombreCliente, nombreSucursal, nombreTurno)
              });
            }
          });

      return turnos;
    },

    llenarDebenAsistirTabla(nombreCliente, nombreSucursal, nombreTurno) {

      const asistentes =[]
      this.json_data_origen.plantilla
      .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno)
      .forEach(d=>{
          const numEmpleado = d[4];
          const ex = asistentes.find(s => s.numEmpleado === numEmpleado)
          if (ex == null) {
            asistentes.push({
              "numEmpleado": numEmpleado,
            });
          }
        });

      return {
        "numeroAsistentes": asistentes.length,
        "asistencias": this.llenarAsistienciasTabla(nombreCliente, nombreSucursal, nombreTurno)
      }

    },

    llenarAsistienciasTabla(nombreCliente, nombreSucursal, nombreTurno) {
      const asistentes = [];
      this.json_data_origen.registros
          .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno
            && d[5] === 'Entrada')
          .forEach(d=>{
            const numEmpleado = d[4];
            const ex = asistentes.find(s => s.numEmpleado === numEmpleado)
            if (ex == null) {
              asistentes.push({
                "numEmpleado": numEmpleado,
              });
            }
          });

      return {
        "numeroAsistentesReales": asistentes.length,
        "evidenciasTurno": this.llenarEvidenciasTurnoTabla(nombreCliente, nombreSucursal, nombreTurno)
      }

    },

    llenarEvidenciasTurnoTabla(nombreCliente, nombreSucursal, nombreTurno) {
      const asistentes =
          this.json_data_origen.plantilla
              .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno);

      return {
        "numEvidenciasTurno": asistentes[0][3],
        "evidencias_tomadas": this.llenarEvidenciasTomadasTabla(nombreCliente, nombreSucursal, nombreTurno)
      }

    },

    llenarEvidenciasTomadasTabla(nombreCliente, nombreSucursal, nombreTurno) {
      const ev_tomadas =
          this.json_data_origen.registros
              .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno
              && d[5] === 'Evidencia');

      return {
        "numEvidenciasTomadas": ev_tomadas.length,
        "empleados": this.llenarEmpleadoTabla(nombreCliente, nombreSucursal, nombreTurno)
      }

    },

    llenarEmpleadoTabla(nombreCliente, nombreSucursal, nombreTurno) {
      const empleados = [];

      this.json_data_origen.plantilla
          .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno)
          .forEach(d=>{
            const numEmpleado = d[4];
            const nombreEmpleado = d[5];
            const ex = empleados.find(s => s.numEmpleado === numEmpleado)
            if (ex == null) {
              empleados.push({
                "numEmpleado": numEmpleado,
                "nombre": nombreEmpleado,
                "registros": this.llenarRegistrosGenerales(nombreCliente, nombreSucursal, nombreTurno, numEmpleado),
                "horasTrabajadas": this.llenarHorasTrabajadas(nombreCliente, nombreSucursal, nombreTurno, numEmpleado)
              });
            }
          });

      return empleados;

    },

    llenarRegistrosGenerales(nombreCliente, nombreSucursal, nombreTurno, numEmpleado) {
      const reg_generales =
          this.json_data_origen.registros
              .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno
                  && d[3] === numEmpleado);
     // console.info("datos_generales", nombreCliente, nombreSucursal, nombreTurno, reg_generales);
      return reg_generales;
    },

    llenarHorasTrabajadas(nombreCliente, nombreSucursal, nombreTurno, numEmpleado) {

      const registrosCompletos = [];
      let totalSegs = 0;

      this.json_data_origen.registros
          .filter(d => d[0] === nombreCliente && d[1] === nombreSucursal && d[2] === nombreTurno
            && d[3] === numEmpleado
            && (d[5] === 'Entrada' || d[5] === 'Salida'))
          .forEach(d=>{
            const tipoRegistro = d[5];
            if (tipoRegistro === 'Entrada') {
              registrosCompletos.push({
                "entrada": d[8],
                "salida": null
              });
            } else  if (tipoRegistro === 'Salida')
              if (registrosCompletos[registrosCompletos.length-1] != null
              && registrosCompletos[registrosCompletos.length-1].salida === null) {
                registrosCompletos[registrosCompletos.length-1].salida = d[8];

                const fecha1 = registrosCompletos[registrosCompletos.length-1].entrada;
                const fecha2 = registrosCompletos[registrosCompletos.length-1].salida;

                const diferenciaSegs = fecha2.diff(fecha1, 's');
                totalSegs += diferenciaSegs;
                // console.info("diferenciaHoras", diferenciaSegs, totalSegs, registrosCompletos[registrosCompletos.length-1]);

            }
          });

      // console.info("totalHoras", registrosCompletos, totalSegs);

      return this.toTime(totalSegs);

    },

    toTime(num) {
      let horas = Math.floor(num / 3600);
      horas = horas < 10 ? '0' + horas : horas;
      let minutos = Math.floor((num / 60) % 60);
      minutos = minutos < 10 ? '0' + minutos : minutos;
      let segundos = num % 60;
      segundos = segundos < 10 ? '0' + segundos : segundos;
      return horas + ':' + minutos + ':' + segundos;
    },

    verDetalle(datos) {

      this.imgModal = null;
      this.registroActivo = datos.datos;

      this.showModal = false;

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.srv_dashboardService.obtenerImagen(datos.token)
          .then((response) => {
            this.imgModal = response;
            this.showModal = true;
          }).catch((error) => {
            this.$swal(error.message);
            console.error(error)
          }).finally(() => load.hide());
    },

    cerrarDetalle() {
      console.info(this.registroActivo[10]);
      document.getElementById(this.registroActivo[10]).scrollIntoView();

      this.showModal = false;
      this.imgModal = null;
      this.registroActivo = null;
    },

    descargarFoto() {

      const a = document.createElement("a"); //Create <a>
      a.href = "data:image/jpg;base64," + this.imgModal; //Image Base64 Goes here
      a.download = this.registroActivo[10]+".jpg"; //File name Here
      a.click(); //Downloaded file
    },

    descargarFotos() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });
      this.srv_dashboardService.obtenerTodasFotos(this.filtros)
          .then((response) => {

            const byteCharacters = atob(response); // Decode Base64 string
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const url = new Blob([byteArray],{type:'application/zip'});

            const a = document.createElement("a"); //Create <a>
            a.href = URL.createObjectURL(url); //Image Base64 Goes here
            a.setAttribute('download', "Fotos.zip");
            a.click(); //Downloaded file
          }).catch((error) => {
        this.$swal(error.message);
        console.error(error)
      }).finally(() => load.hide());
    },
  },
  filters: {}
};
</script>

<style scoped>
  .popTitle{
    background: none;
    border: none;
    font-weight: bold;
  }
</style>


<style>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 32px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>